<div *ngIf="step" class="user-update">
  <form novalidate #currentForm="ngForm">
    <div class="group">
      <p>First name *</p>
      <input
        autocomplete="off"
        name="firstName"
        [(ngModel)]="firstName"
        #firstNameInput="ngModel"
        (ngModelChange)="firstNameUpdated()"
        maxlength="30"
        required
      />
      <div
        class="error"
        *ngIf="firstNameInput.invalid && (firstNameInput.dirty || firstNameInput.touched)"
      >
        <mat-error *ngIf="firstNameInput.errors.maxlength">First name is too long.</mat-error>
        <mat-error *ngIf="firstNameInput.errors.required">First name is required.</mat-error>
      </div>
    </div>
    <div class="group">
      <p>Last name</p>
      <input
        autocomplete="off"
        name="lastName"
        [(ngModel)]="lastName"
        #lastNameInput="ngModel"
        (ngModelChange)="lastNameUpdated()"
        maxlength="30"
      />
      <div
        class="error"
        *ngIf="lastNameInput.invalid && (lastNameInput.dirty || lastNameInput.touched)"
      >
        <mat-error *ngIf="lastNameInput.errors.maxlength">Last name is too long.</mat-error>
      </div>
    </div>
    <div class="group">
      <p>Email *</p>
      <input
        autocomplete="off"
        name="email"
        placeholder="Enter email address"
        [(ngModel)]="email"
        minlength="5"
        maxlength="100"
        #emailInput="ngModel"
        (ngModelChange)="emailUpdated()"
        [pattern]="emailRegEx"
        required
      />
      <div class="error" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
        <mat-error *ngIf="emailInput.errors.minlength">Your email is too short.</mat-error>
        <mat-error *ngIf="emailInput.errors.maxlength">Your email is too long.</mat-error>
        <mat-error *ngIf="emailInput.errors.required">Your email is required.</mat-error>
        <mat-error *ngIf="emailInput.errors.pattern">Email is invalid.</mat-error>
      </div>
    </div>
  </form>
</div>
